import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CharterType } from 'anchor-shared/lib/model/enum/charter-type';

@Component({
  selector: 'app-buyflow-cancellation-dialog',
  templateUrl: './buyflow-cancellation-dialog.component.html',
  styleUrls: ['./buyflow-cancellation-dialog.component.scss'],
})
export class BuyflowCancellationDialogComponent implements OnInit {
  charterType: CharterType;
  CharterType = CharterType;

  constructor(
    private dialogRef: MatDialogRef<BuyflowCancellationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.charterType = data.charterType;
  }

  ngOnInit(): void {}

  getPolicyLink() {
    if (this.charterType === CharterType.DayCharter) {
      return 'https://anchor-public-media.s3.us-east-2.amazonaws.com/prod/Day_Charter_Cancellation_Policy_08_10_2024.pdf';
    } else {
      return 'https://anchor-public-media.s3.us-east-2.amazonaws.com/prod/Term_Charter_Cancellation_Policy_08_10_2024.pdf';
    }
  }
}
